export const specials = [
  {
    id: "s1",
    title: "经典激情电影集",
    subtitle: "那些年让我们心跳加速的光影瞬间",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20collage%20concept%20of%20classic%20passionate%20romance%20films%2C%20warm%20crimson%20and%20gold%20toned%20theater%20with%20glowing%20projector%20beam%2C%20vintage%20film%20reels%2C%20nostalgic%20premium%20cinematic%20atmosphere%2C%20elegant%20editorial%20composition&width=800&height=600&seq=pv-special-01&orientation=landscape",
    reason: "精选影史中极具张力的爱情与激情题材影片，从克制到炽烈，一次看尽爱情的不同温度。",
    intro:
      "有些电影，看时心动，看完难忘。“经典激情电影集”收录了最具代表性的激情题材佳作，它们用镜头记录爱情的灼热、遗憾与壮烈，是每个影迷都值得反复回味的银幕记忆。",
    groups: [
      { name: "银幕初恋", desc: "纯真年代的第一次心动", movies: ["血色浪漫", "逆光之恋"] },
      { name: "燃烧与克制", desc: "成年人的爱情拉扯", movies: ["烈火之心", "南风知我意"] },
    ],
  },
  {
    id: "s2",
    title: "新发现剧集推荐",
    subtitle: "正在被越来越多人讨论的新锐之作",
    cover:
      "https://readdy.ai/api/search-image?query=Fresh%20modern%20streaming%20series%20concept%2C%20floating%20glowing%20screens%20in%20a%20dark%20room%20with%20warm%20amber%20and%20crimson%20glow%2C%20futuristic%20entertainment%20vibe%2C%20clean%20premium%20cinematic%20composition&width=800&height=600&seq=pv-special-02&orientation=landscape",
    reason: "口碑正在上升的黑马作品合集，剧情新颖、风格大胆，适合想尝鲜的你看点不一样的。",
    intro:
      "别只盯着大热门，真正的好剧常常藏在角落里悄然发光。“新发现剧集推荐”为你挖掘近期口碑上佳、风格独特的新作，从梦境悬疑到氛围短片，总有一部会成为你的下一个心头好。",
    groups: [
      { name: "脑洞新剧", desc: "设定独特，越看越上头", movies: ["炽爱迷宫", "霓虹之下"] },
      { name: "氛围短片", desc: "短小精悍，风格强烈", movies: ["长夜燃灯"] },
    ],
  },
  {
    id: "s3",
    title: "都市情感专题",
    subtitle: "在城市森林里，遇见同频的人",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20concept%20with%20glowing%20city%20skyline%20at%20dusk%20seen%20through%20rain%20covered%20glass%2C%20warm%20amber%20and%20muted%20red%20reflections%2C%20sophisticated%20emotional%20mood%2C%20premium%20cinematic%20composition&width=800&height=600&seq=pv-special-03&orientation=landscape",
    reason: "聚焦都市男女的情感日常，职场、生活与心动交织，献给每一个在城市里认真生活的你。",
    intro:
      "高楼林立，灯火通明，最难的从来不是工作，而是找到那个懂你的人。“都市情感专题”收录了多部贴近现实的都市情感剧，讲述奋斗、选择与心动，真实得让人频频点头。",
    groups: [
      { name: "职场心动", desc: "双强相遇，棋逢对手", movies: ["都市迷情"] },
      { name: "岁月同行", desc: "一起走过青春与成长", movies: ["燃情岁月", "逆光之恋"] },
    ],
  },
  {
    id: "s4",
    title: "悬疑激情季",
    subtitle: "当爱与真相同时失控",
    cover:
      "https://readdy.ai/api/search-image?query=Suspense%20thriller%20concept%20with%20rainy%20dark%20alley%20lit%20by%20warm%20red%20neon%2C%20a%20single%20red%20rose%20on%20wet%20ground%2C%20tense%20moody%20atmosphere%2C%20premium%20noir%20cinematic%20composition&width=800&height=600&seq=pv-special-04&orientation=landscape",
    reason: "悬疑与情感双线推进，一边是烧脑反转，一边是爱恨纠缠，看得停不下来。",
    intro:
      "最深的谜底，往往藏在最深的爱里。“悬疑激情季”集合了悬疑与犯罪题材中的情感佳作，案件背后是人性的挣扎，真相揭晓时，你会为谁心疼？",
    groups: [
      { name: "罪案迷情", desc: "在追凶中遇见爱", movies: ["暗夜玫瑰", "罪爱双生"] },
    ],
  },
  {
    id: "s5",
    title: "年代爱情特辑",
    subtitle: "时光慢，一生只够爱一个人",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%201990s%20era%20concept%20with%20vintage%20street%2C%20old%20bicycles%20leaning%20against%20weathered%20walls%2C%20warm%20crimson%20and%20faded%20gold%20sunset%20light%2C%20soft%20film%20grain%2C%20bittersweet%20cinematic%20atmosphere&width=800&height=600&seq=pv-special-05&orientation=landscape",
    reason: "回溯旧时光里的爱情，质朴、炽热又动人，带你重温那个慢节奏的浪漫年代。",
    intro:
      "没有手机的年代，思念要靠书信，喜欢要用一生去证明。“年代爱情特辑”精选多部年代情感剧，讲述在时代浪潮中依然坚定的爱情，质朴而滚烫。",
    groups: [
      { name: "旧城往事", desc: "老街、单车与初恋", movies: ["血色浪漫"] },
      { name: "工厂青春", desc: "奋斗岁月里的并肩", movies: ["燃情岁月"] },
    ],
  },
  {
    id: "s6",
    title: "女性视角精选",
    subtitle: "她们的故事，她们的锋芒",
    cover:
      "https://readdy.ai/api/search-image?query=Empowering%20feminine%20cinematic%20concept%2C%20elegant%20silhouette%20of%20a%20confident%20woman%20against%20warm%20crimson%20and%20gold%20gradient%20light%2C%20graceful%20artistic%20mood%2C%20premium%20editorial%20composition&width=800&height=600&seq=pv-special-06&orientation=landscape",
    reason: "以女性为主角与视角的作品合集，聚焦她们的成长、选择与爱，细腻而有力量。",
    intro:
      "温柔是力量，倔强也是。“女性视角精选”收录了多部以女性成长为核心的影视作品，她们在爱与被爱中学会独立，在失去与得到间找到自己。",
    groups: [
      { name: "她的成长", desc: "从依附到独立", movies: ["烈火之心", "逆光之恋"] },
      { name: "静谧之爱", desc: "无声处听心跳", movies: ["深海之吻"] },
    ],
  },
];

export const starNews = [
  { title: "林述凭《烈火之心》再获关注，观众盛赞“眼神都是戏”", starId: "1", date: "10月8日" },
  { title: "苏晚棠新剧《都市迷情》热播，双强设定引发追剧热潮", starId: "2", date: "10月6日" },
  { title: "顾承川《暗夜玫瑰》收官，悬疑尺度与情感张力雙获好评", starId: "3", date: "10月4日" },
];